import React from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'button'>,
  {
    label: React.ReactNode
    onClear?: React.MouseEventHandler
    emphasized?: boolean
    disabled?: boolean
  }
>

const Chip = ({
  className,
  label,
  emphasized = false,
  disabled = false,
  onClear,
  ...props
}: Props) => (
  <button
    {...props}
    className={cn('Chip', {clear: !!onClear, emphasized, disabled}, className)}
    type="button"
    onClick={!onClear || disabled ? undefined : onClear}
    disabled={disabled}
  >
    <span className="Chip__label">{label}</span>
    {onClear && (
      <span className="Chip__clear">
        <Icon source={closeIcon} />
      </span>
    )}
  </button>
)

export default Chip
